
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrazione-newsletter",
      function () {
        return require("private-next-pages/registrazione-newsletter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrazione-newsletter"])
      });
    }
  